<template>
<div class="tlhold px-3">
      <v-timeline dense clipped v-if="invoiceActivities.length > 0">
        <v-slide-x-transition
            group
          >
        <div v-for="(item, index) in timelineByDate" :key="index" px-3>
        <v-timeline-item v-if="item.status === 'Paid'"
          class="mb-1"
          color="accent"
          icon="sentiment_satisfied_alt"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Paid online by {{item.by}}</span>
            </v-flex>
            <v-flex xs12>
              <a :href='item.paymentReceipt' class="body-small fadegrey--text" target="_blank">View receipt</a>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Marked as paid'"
          class="mb-1"
          color="accent"
          icon="sentiment_satisfied_alt"
        >
          <v-layout row wrap>
            <v-flex xs12><span class="body-small">Marked as paid</span>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }} by {{item.by}}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Marked as unpaid'"
          class="mb-1"
          color="accent"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
                <span class="body-small">Marked as unpaid</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }} by {{item.by}}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Sent'"
          class="mb-1"
          color="accent"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Invoice emailed to
                <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{item.to.length}} {{item.to.length | pluralize('person', 'people')}} </u></span>
                  <span v-for="person in item.to" :key="person.id">{{person}}<br> </span>
                </v-tooltip>
              </span>
            </v-flex>
            <v-flex xs12 pb-1>
              <email-view :item="item"></email-view>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Chase Email'"
          class="mb-1"
          color="grey"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Chase Email to
                <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{client.emails.length}} {{client.emails.length | pluralize('person', 'people')}} </u></span>
                  <span v-for="person in client.emails" :key="person.id">{{person}}<br> </span>
                </v-tooltip>
              </span>
            </v-flex>
            <v-flex xs12 pb-1>
              <email-view :item="{
                ...item,
                to: client.emails,
                fromName: group.title,
                from: group.email,
                invoiceTitle: invoice.title,
                invoice_ref: invoice.invoice_ref
                }" ></email-view>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Chase Email Sent'"
          class="mb-1"
          color="green"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Chase Email Sent to
                <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{client.emails.length}} {{client.emails.length | pluralize('person', 'people')}} </u></span>
                  <span v-for="person in client.emails" :key="person.id">{{person}}<br> </span>
                </v-tooltip>
              </span>
            </v-flex>
            <v-flex xs12 pb-1>
              <email-view :item="{...item, to: client.emails, fromName: group.title, from: group.email}" ></email-view>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Quote sent'"
          class="mb-1"
          color="accent"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Quote emailed to
                <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{item.to.length}} {{item.to.length | pluralize('person', 'people')}} </u></span>
                  <span v-for="person in item.to" :key="person.id">{{person}}<br> </span>
                </v-tooltip>
              </span>
            </v-flex>
            <v-flex xs12 pb-1>
              <email-view :item="item"></email-view>
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Marked as sent'"
          class="mb-1"
          color="accent"
          small
        >
          <v-layout row wrap>
            <v-flex xs12><span class="body-small">Marked as sent</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }} by {{item.by}}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Marked as unsent'"
          class="mb-1"
          color="accent"
          small
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">Marked as unsent</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }} by {{item.by}}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="(item.status === 'Opened') || (item.status === 'Quote opened')"
          class="mb-1"
          small
          color="accent"
        >
          <v-layout row wrap>
            <v-flex xs12>
                <span class="body-small">{{item.status}} by {{item.by}}</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Quote accepted'"
          class="mb-1"
          small
          color="accent"
        >
          <v-layout row wrap>
            <v-flex xs12>
                <span class="body-small">{{item.status}} by {{item.by}}</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        <v-timeline-item v-else-if="item.status === 'Downloaded'"
          class="mb-1"
          small
          color="accent"
        >
          <v-layout row wrap>
            <v-flex xs12>
                <span class="body-small">Downloaded</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
          <v-timeline-item v-else
          class="mb-1"
          small
          color="accent"
        >
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-small">{{item.status}}</span>
              </v-flex>
            <v-flex xs12>
              <v-tooltip bottom color="primary">
                <span slot="activator" class="caption"><u>{{ formatDateFromNow(item.created) }}</u></span>
                <span>{{ formatDateToDateAndMins(item.created) }} by {{item.by}}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-timeline-item>
        </div>
        </v-slide-x-transition>
      </v-timeline>
      <v-container fill-height v-else>
        <v-layout>
          <v-flex class="text-xs-center">
            <v-icon size="200px" color="rgba(0,0,0,.1)">history</v-icon>
            <p class="body-small mt-3 subtle" color="rgba(0,0,0,.1)">This panel will show the activity of the invoice through it's lifecycle from Sent to Paid.</p>
          </v-flex>
        </v-layout>
      </v-container>
      </div>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'
import EmailView from '@/components/Invoice/EmailView'

export default {
  name: 'Timeline',
  components: {
    EmailView
  },
  props: {
    invoiceActivities: {
      type: Array
    },
    client: {
      type: Object
    },
    invoice: {
      type: Object
    },
    group: {
      type: Object
    }
  },
  computed: {
    timelineByDate () {
      const timeline = this.invoiceActivities
      return timeline.sort((a, b) => {
        return new Date(b.created) - new Date(a.created)
      })
    }
  },
  mixins: [formatDate]
}
</script>

<style lang="scss">
  .v-timeline--dense .v-timeline-item__body{
    max-width: calc(100% - 40px);
  }
  .v-timeline-item__dot--small .v-timeline-item__inner-dot{
    height:12px !important;
    width:12px !important;
    margin:6px;
  }
</style>
